import { createPortal } from 'react-dom'

import Experiment from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'

import { CONCIERGE_EXPERIENCE_FLAG_NAME } from '../constants'
import { CONCIERGE_EXPERIENCE_I18N_NAMESPACE } from '../i18n/i18nInstance'
import {
  FabOptionsVariant1,
  FabOptionsVariant2,
  FabOptionsVariant3,
} from './FabOptions'
import { ExplainerScreen } from './ExplainerScreen'
import { useFab } from './FabProvider'
import classes from './Fab.module.scss'

export const FloatingActionContent = () => {
  const { t } = useTranslation(CONCIERGE_EXPERIENCE_I18N_NAMESPACE)
  const { showFab, isOpened, view } = useFab()

  const showActionContent = showFab && isOpened

  return (
    <>
      {showActionContent && (
        <div
          className='d-flex justify-content-end mc-mr-6 mc-mb-4'
          style={{ zIndex: 1000 }}
        >
          <div
            className={`mc-bg-container-tint-dark mc-p-4 mc-corners--sm ${classes.Container}`}
          >
            {view === 'explainer' && <ExplainerScreen />}
            {view === 'content' && (
              <>
                <p className='mc-text-h5 mc-mb-4'>{t('fab.title')}</p>
                <Experiment
                  name={CONCIERGE_EXPERIENCE_FLAG_NAME}
                  variant_1={FabOptionsVariant1}
                  variant_2={FabOptionsVariant2}
                  variant_3={FabOptionsVariant3}
                  track={false}
                />
              </>
            )}
          </div>
        </div>
      )}

      <PageOverlay show={showActionContent} />
    </>
  )
}

const PageOverlay = ({ show }: { show: boolean }) => (
  <div>
    {/* createPortal will render the overlay directly in the document body, this should make 
    it cover the entire page regardless of where FloatingActionContent is rendered */}
    {createPortal(
      <div
        style={{
          position: 'fixed',
          inset: 0,
          width: '100vw',
          height: '100dvh',
          background: 'rgba(0, 0, 0, 0.60)',
          zIndex: 999,
          opacity: show ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
          pointerEvents: show ? 'auto' : 'none',
        }}
      />,
      document.body,
    )}
  </div>
)
